import React from 'react'
import { MerchantLocationsLoader, LoaderSwitcher } from 'router/Loaders'
import Home from 'components/Home'

export const HomeWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <LoaderSwitcher isParentLoaded={isParentLoaded}>
          <Home />
        </LoaderSwitcher>
      )}
    </MerchantLocationsLoader>
  )
}
